<div class="d-flex flex-column shape-info-window">
  <div class="location-container">
    <p class="d-flex mb-1">
      <span class="label">Start: </span>
      <span>{{leg.start_address}}</span>
    </p>
    <p class="d-flex mb-0">
      <span class="label">End: </span>
      <span>{{leg.end_address}}</span>
    </p>
  </div>
  <div class="scroll-container">
    <div class="directions-wrap">
      <div class="directions-info mb-0 p-0 d-flex justify-content-between">
        <span>
          <span class="label">Time:</span> {{leg.duration.text}}
        </span>
        <span>
          <span class="label">Distance:</span> {{leg.distance.text}}
        </span>
      </div>
      <ul class="directions-list mb-0">
        <li *ngFor="let step of leg.steps">
          <span [innerHTML]="step.instructions + ', go ' + step.distance.text"></span>
        </li>
      </ul>
    </div>
  </div>
  <div class="m-0 info-lane info-lane--driving d-flex justify-content-around">
    <button type="button" class="btn-custom btn-small" (click)="clear()">
      <i class="far fa-trash-alt" aria-hidden="true"></i>Clear
    </button>
    <button type="button" class="btn-custom btn-small ml-0" (click)="sendEmail()">
      <i class="far fa-envelope" aria-hidden="true"></i>Email
    </button>
  </div>
</div>
